import { useEffect } from 'react';
import useApi from './useApi';
import { useStowageRuleStore } from '../context/StowageRuleContext';
import useApiEndpoints from '../context/useApiEndpoints';
import apiEndpointUtils from 'src/utils/apiEndpointUtils';
import { StowageRuleBM } from 'src/types/BusinessModel/Stowage/StowageRule/StowageRuleBM';
import { StowageRulesMapsBM } from 'src/types/BusinessModel/Stowage/StowageRule/StowageRulesMapsBM';

export default () => {
    const { apiEndpoints } = useApiEndpoints();
    const { processApiEndpointError } = apiEndpointUtils();
    const { state, getApiData } = useApi();
    const { setStowageRules, setStowageRulesMaps } = useStowageRuleStore();

    const getStowageRules = async () => {
        const result = await getApiData({
            endpoint: apiEndpoints['getStowageRules'].url,
        });

        if (result) {
            const stowageRuleBMs = result as StowageRuleBM[];

            setStowageRules([...stowageRuleBMs]);
            return stowageRuleBMs;
        }
    };
    const getStowageRulesMaps = async () => {
        const result = await getApiData({
            endpoint: apiEndpoints['getStowageRulesMaps'].url,
        });

        if (result) {
            const stowageRulesMapsBM = result as StowageRulesMapsBM;

            setStowageRulesMaps(stowageRulesMapsBM);
            return stowageRulesMapsBM;
        }
    };

    useEffect(() => {
        processApiEndpointError(state);
    }, [state]);

    return { state, getStowageRules, getStowageRulesMaps };
};
